export const SIDEBAR_WIDTH = 272;
export const TOPBAR_HEIGHT = 68;

export type NavSection = { label: string; items: NavItem[] };
export type NavItem = {
  label: string;
  href: string;
  icon: string;
  badge?: number;
};

export const ENTERPRISE_WALLET_NAV_SECTIONS: NavSection[] = [
  {
    label: "Platform",
    items: [
      { label: "Home", href: "/home", icon: "Home" },
      { label: "Wallets", href: "/wallets", icon: "Wallet", badge: 1 },
      { label: "Transfers", href: "/transfers", icon: "ArrowUpDown" },
      { label: "Approvals", href: "/approvals", icon: "CheckCircle", badge: 3 },
      { label: "Developer", href: "/developer", icon: "Code" },
    ],
  },
  {
    label: "Treasury",
    items: [{ label: "Treasury", href: "/treasury", icon: "Landmark" }],
  },
  {
    label: "Oversight",
    items: [
      { label: "Governance", href: "/governance", icon: "Shield" },
      { label: "Monitoring", href: "/monitoring", icon: "Activity" },
      { label: "Reconciliation", href: "/reconciliation", icon: "RefreshCw", badge: 5 },
      { label: "Evidence", href: "/evidence", icon: "FileText" },
    ],
  },
  {
    label: "Account",
    items: [
      { label: "Recovery", href: "/recovery", icon: "KeyRound" },
      { label: "Settings", href: "/settings", icon: "Settings" },
    ],
  },
];

export const ADMIN_PORTAL_NAV_SECTIONS: NavSection[] = [
  {
    label: "Deployment",
    items: [{ label: "Deployment", href: "/admin/deployment", icon: "Container" }],
  },
  {
    label: "Organization",
    items: [
      { label: "Users", href: "/admin/users", icon: "Users" },
      { label: "Roles", href: "/admin/roles", icon: "UserCog" },
      { label: "Groups", href: "/admin/groups", icon: "Users" },
      { label: "Service Accounts", href: "/admin/service-accounts", icon: "Server" },
      { label: "Audit Trail", href: "/admin/audit-log", icon: "ScrollText" },
    ],
  },
  {
    label: "Configuration",
    items: [
      { label: "Organization", href: "/admin/org", icon: "Building2" },
      { label: "Auth Config", href: "/admin/auth-config", icon: "ShieldCheck" },
      { label: "Services", href: "/admin/services", icon: "Server" },
    ],
  },
];

export const ORG_ENV = "Production";

export const MOCK_USER = {
  name: "Sai Suman Kanuganti",
  email: "daniel.okafor@example.com",
  initials: "SK",
  role: "Org Admin",
};
